// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_modules_badges_js") return "./js/chunks/fe54efc080d453ccdd96.js";
	if (chunkId === "assets_js_modules_calculator_js") return "./js/chunks/cba5f279101dce993033.js";
	if (chunkId === "assets_js_modules_footer_js") return "./js/chunks/fb29320098597049c52c.js";
	if (chunkId === "assets_js_modules_header_js") return "./js/chunks/3e1ee8e314428c30b101.js";
	if (chunkId === "vendors-node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs") return "./js/chunks/c232e0d67dacbd2befcf.js";
	if (chunkId === "assets_js_modules_slider_js") return "./js/chunks/2d3a413bc5904906db2e.js";
	if (chunkId === "assets_js_modules_sliderBlog_js") return "./js/chunks/8c65457e66973501b258.js";
	if (chunkId === "assets_js_modules_video_js") return "./js/chunks/baa5b8ce64013af9fb72.js";
	// return url for filenames based on template
	return undefined;
};